export enum TCompanyId {
    COMPANY_ID = 'companyId',
    EMPLOYER_ID = 'employerId'
}

export type TInfoPath = {
    type: TCompanyId
    id: string
}

export type TMetaHead = {
    title: string
    description: string
    canonicalUrl?: string
    robots?: string
}

export const getCompanyId = (path: string) => {
    const splittedPath = path.split('-')
    const type = splittedPath[splittedPath.length - 1][0]
    const id = splittedPath[splittedPath.length - 1].slice(1)

    return {
        type: type === 'c' ? TCompanyId.COMPANY_ID : TCompanyId.EMPLOYER_ID,
        id
    }
}

export const getInfoFromUrl = (url: string) => {
    let path = url
    let params = ''

    const questionSplit = url.split('?')
    if (questionSplit.length === 2) {
        params = questionSplit[1]
        path = questionSplit[0]
    }

    const splittedPath = path.split('/')

    return {
        path: splittedPath[splittedPath.length - 1],
        params: params ? `?${params}` : ''
    }
}

export const buildQueryString = (params: any): string => {
    if (!params || typeof params !== 'object') {
        return ''
    }

    const queryString = Object.keys(params)
        .map((key) => {
            const encodedKey = encodeURIComponent(key)
            const encodedValue = encodeURIComponent(params[key])
            return `${encodedKey}=${encodedValue}`
        })
        .join('&')

    return queryString
}
